import { SvgIcon, Link } from "@material-ui/core";
import { ReactComponent as Twitter } from "../../assets/icons/twitter.svg";
import { ReactComponent as Discord } from "../../assets/icons/discord.svg";
import { ReactComponent as Github } from "../../assets/icons/github.svg";
import { ReactComponent as Youtube } from "../../assets/icons/youtube.svg";
import { ReactComponent as Instagram } from "../../assets/icons/instagram.svg";
import { ReactComponent as Monogram } from "../../assets/icons/medium.svg";
import { ReactComponent as Linktree } from "../../assets/icons/linktree.svg";
import { ReactComponent as Telegram } from "../../assets/icons/telegram.svg";
import { ReactComponent as Facebook } from "../../assets/icons/facebook.svg";
import { ReactComponent as Tiktok } from "../../assets/icons/tiktok.svg";
import { ReactComponent as Reddit } from "../../assets/icons/reddit.svg";

export default function Social() {
    return (
        <div className="social-row">
            <Link className={"social-item"} href="https://twitter.com/DiamondBankDao" target="_blank" style={{ color: "white" }}>
                <SvgIcon color="inherit" component={Twitter} />
            </Link>

            <Link className={"social-item"} href="https://t.me/diamondbankdao" target="_blank" style={{ color: "white" }}>
                <SvgIcon color="inherit" component={Telegram} />
            </Link>

            <Link className={"social-item"} href="discord.gg/diamondbankdao" target="_blank" style={{ color: "white" }}>
                <SvgIcon color="inherit" component={Discord} />
            </Link>

            {/* <Link className={"social-item"} href="https://discord.gg/Q4dDmtuT" target="_blank" style={{ color: "white" }}>
                <SvgIcon color="inherit" component={Linktree} />
            </Link> */}

            <Link className={"social-item"} href="https://diamondbank.medium.com/" target="_blank" style={{ color: "white" }}>
                <SvgIcon color="inherit" component={Monogram} />
            </Link>

            <Link className={"social-item"} href="https://www.instagram.com/diamondbankdao/" target="_blank" style={{ color: "white" }}>
                <SvgIcon color="inherit" component={Instagram} />
            </Link>

            <Link className={"social-item"} href="https://www.youtube.com/channel/UCZKKHOD_lXJEi0EwGT94Wqw" target="_blank" style={{ color: "white" }}>
                <SvgIcon color="inherit" component={Youtube} />
            </Link>

            <Link className={"social-item"} href="https://diamond-bank-dao.gitbook.io/welcome-to-gitbook/" target="_blank" style={{ color: "white" }}>
                <SvgIcon color="inherit" component={Github} />
            </Link>

            <Link className={"social-item"} href="https://www.facebook.com/DiamondBankDao/" target="_blank" style={{ color: "white" }}>
                <SvgIcon color="inherit" component={Facebook} />
            </Link>

            <Link className={"social-item"} href="https://www.tiktok.com/@diamondbankdao?" target="_blank" style={{ color: "white" }}>
                <SvgIcon color="inherit" component={Tiktok} />
            </Link>

            <Link className={"social-item"} href="https://www.reddit.com/r/diamondbank/" target="_blank" style={{ color: "white" }}>
                <SvgIcon color="inherit" component={Reddit} />
            </Link>
        </div>
    );
}
